/** getConnection exposes no provider error code. Only these SDK-owned messages are classified. */
export class FundingConnectionError extends Error {
    diagnostic;
    constructor(error) {
        super('provider_unavailable');
        this.name = 'FundingConnectionError';
        this.diagnostic =
            error.message === 'Frame handshake timed out'
                ? 'connection_frame_timeout'
                : error.message === 'Get connection timed out'
                    ? 'connection_check_timeout'
                    : 'connection_failed';
    }
}
export function connectionFailureCode(error) {
    return error instanceof FundingConnectionError ? error.diagnostic : null;
}
